<!--  -->
<template>
  <div class="active-success">
    <van-popup v-model="show" position="center" :style="{ height: '250px', width: '275px' }" duration="0.18" round>
      <van-icon @click="show = false" name="cross" />
      <img class="icon" src="@/assets/img/personalCenter/active-success.png" alt="" />
      <p class="name">激活成功</p>
      <button class="btn" @click="myCourse">{{ isEbook ? '查看我的图书' : '查看我的课程' }}</button>
    </van-popup>
  </div>
</template>

<script>
import { judgmentPlatform, goApp } from '@/utils/tools';
import wx from 'weixin-js-sdk';

export default {
  props: {
    isEbook: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    myCourse() {
      console.log('是否是电子书', this.isEbook ? '是' : '否');
      if (this.$root.$data.isApp) {
        // 电子书需要判断版本号
        if (this.isEbook) {
          if (judgmentPlatform() === 'HarmonyOS') {
            this.$toast('当前设备不支持，请更换ios/Android最新版学习');
          } else if ((judgmentPlatform() === 'android' && !this.$root.checkVersion('5.8.4')) || (judgmentPlatform() === 'ios' && !this.$root.checkVersion('5.8.6'))) {
            this.$toast('请更新最新版本后开始学习');
          } else {
            this.$sendToApp('goEBookListPage');
          }
        } else {
          this.$sendToApp('goLearnCenterPage', {}, false);
        }
      } else if (this.$root.$data.miniprogram) {
        if (this.isEbook) {
          wx.miniProgram.navigateTo({ url: '/eBook/eBookList/index' });
        } else {
          wx.miniProgram.navigateTo({ url: '/myCourse/courseList/index' });
        }
      } else {
        if (!this.isEbook) {
          this.$router.push({ path: '/personalCenter/mycourseList' });
        }
        if (goApp()) {
          this.$toast('请前往启航教育app查看电子书');
        }
      }
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.active-success {

  // padding: 20px 0 0 0;
  ::v-deep .van-popup--center.van-popup--round {
    border-radius: 8px !important;
  }

  ::v-deep .van-icon {
    position: absolute;
    top: 14px;
    right: 14px;
    color: #333;
    font-size: 24px;
  }

  .icon {
    display: block;
    width: 96px;
    margin: 100px auto 0;
  }

  .name {
    padding: 44px 0;
    color: #333;
    font-weight: 600;
    font-size: 32px;
    text-align: center;
  }

  .btn {
    display: block;
    width: 362px;
    height: 80px;
    margin: 0 auto;
    color: #fff;
    font-weight: 600;
    font-size: 32px;
    background: #ff6c02;
    border-radius: 50px;
  }
}
</style>
